import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import {catchError, map, take, tap} from 'rxjs/operators';
import { HttpService } from '../services/http.service';
import {Auth} from "../../aplicacao/models/auth.model";
import {BaseProviderService} from "../../services/base-provider.service";
import {EnvioCnds} from "../../aplicacao/models/envioCnds.model";
import {AlertaService} from "../../bibliotecaPjus/services/alerta.service";
import {NgxSpinnerService} from "ngx-spinner";
import {DadosJwtService} from "../services/dados-jwt.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseProviderService {
  protected module = 'Login';
  constructor(
    protected http: HttpClient,
    private httpService: HttpService,
    protected alertaService: AlertaService,
    protected dadosJwtService: DadosJwtService,
    private spinner: NgxSpinnerService
  ) {
    super(http);
  }

  httpOptions = {
		headers: new HttpHeaders({
			"Content-Type": "application/json; charset=UTF-8",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*"
		})
	};

  login(model: Auth): Observable<Auth> {
    return this.http.post<Auth>(this.getUrl(this.v1, this.module), model, this.httpOptions ).pipe(take(1) ,tap((res: Auth) => {
      this.dadosJwtService.set(res.chave);
    }), catchError((e): Observable<any> => {
      this.spinner.hide();
      if (e?.error?.key === 'LoginNaoAutorizadoPrimeiroAcesso') {
        this.httpService.navigate(['auth/primeiro-acesso/' + model.usuario]);
      } else {
        this.alertaService.erro('Usuário ou senha inválidos!');
      }
      return EMPTY;
    }));
  }

  alterarSenha(model: any): Observable<Auth> {
    return this.http.post<Auth>(this.getUrl(this.v1, this.module, ['alterarSenha']), model, this.httpOptions ).pipe(take(1) ,tap((res: Auth) => {
      this.dadosJwtService.set(res.chave);
    }), catchError((e): Observable<any> => {
      this.spinner.hide();
      if (e?.error?.key === 'LoginNaoAutorizadoPrimeiroAcesso') {
        this.httpService.navigate(['auth/primeiro-acesso/' + model.usuario]);
      } else {
        this.alertaService.erro('Usuário ou senha inválidos!');
      }
      return EMPTY;
    }));
  }

  recuperarSenha(model: any): Observable<Auth> {
    return this.http.post<Auth>(this.getUrl(this.v1, this.module, ['recuperarSenha?usuario=' +  model.usuario]), model).pipe(take(1) ,tap((res: Auth) => {
      this.spinner.hide();
      this.httpService.navigate(['auth/recuperacao-senha/' + model.usuario]);
    }), catchError((e): Observable<any> => {
      this.spinner.hide();
      this.alertaService.erro('Opps, ocorreu um erro!');
      return EMPTY;
    }));
  }
  recuperacaoSenha(model: any): Observable<Auth> {
    return this.http.post<Auth>(this.getUrl(this.v1, this.module, [`validarRecuperacaoSenha`]), model).pipe(take(1) ,tap((res: Auth) => {
      this.spinner.hide();
      this.httpService.navigate(['auth/']);
    }), catchError((e): Observable<any> => {
      this.spinner.hide();
      this.alertaService.erro('Opps, ocorreu um erro!');
      return EMPTY;
    }));
  }
  logout(){
    localStorage.clear();
    this.httpService.navigate(['/auth/login']);
  }
  removeAuthToken(){
    return localStorage.removeItem('AuthToken');
  }
}
